"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { createStore } from "zustand/vanilla";
import _ from "lodash";
import { subscribeWithSelector } from "zustand/middleware";
import pointStore from "./pointStore";
import geoStore from "./geoStore";
import dropdownFilterStore from "../stores/dropdownFilterStore";
import pointCounterStore from "../stores/pointCounterStore";
const sortingIteratee = (filter) => JSON.stringify(filter);
const store = createStore(
  subscribeWithSelector((set, get) => ({
    defaultFilters: [],
    activeFilters: [],
    setDefaultFilters: (filters = []) => {
      const sortedFilters = _.sortBy(filters, [sortingIteratee]);
      set(() => ({
        defaultFilters: sortedFilters
      }));
    },
    isFilteredByScope: (filters = void 0) => {
      const { scopeFilter } = store.getState();
      return !!scopeFilter(filters);
    },
    scopeFilter: (filters = void 0) => {
      var _a, _b;
      if (!filters) {
        const { activeFilters } = store.getState();
        filters = activeFilters;
      }
      return (_b = (_a = filters.find(({ scopeFilter }) => scopeFilter)) == null ? void 0 : _a.scopeFilter) == null ? void 0 : _b.scopeId;
    },
    isFilteredByTime: (filters = void 0) => {
      if (!filters) {
        const { activeFilters } = store.getState();
        filters = activeFilters;
      }
      return !!filters.find(({ timeFilter }) => timeFilter);
    },
    hasUserFilters: () => {
      const { defaultFilters, activeFilters } = store.getState();
      return _.isEqual(defaultFilters, activeFilters);
    },
    setFilters: (filters = []) => {
      const activeFilters = _.sortBy(filters, [sortingIteratee]);
      set((state) => {
        if (_.isEqual(state.activeFilters, activeFilters)) return {};
        return { activeFilters };
      });
    },
    resetFilters: () => {
      set((state) => ({
        activeFilters: state.defaultFilters
      }));
    },
    /**
     * Check if the map to displays is only for processes
     * @returns bool if serverside required  a participatory process type map only
     */
    isProcessOnly() {
      const { defaultFilters } = get();
      const resourceFilter = defaultFilters.find(
        ({ resourceTypeFilter = void 0 }) => resourceTypeFilter
      );
      if (!resourceFilter) return false;
      const { resourceType } = resourceFilter.resourceTypeFilter;
      return resourceType === "participatory_processes";
    },
    /**
     *
     * @returns bool if serverside require a assembly type map only
     */
    isAssemblyOnly() {
      const { defaultFilters } = get();
      const resourceFilter = defaultFilters.find(
        ({ resourceTypeFilter = void 0 }) => resourceTypeFilter
      );
      if (!resourceFilter) return false;
      const { resourceType } = resourceFilter.resourceTypeFilter;
      return resourceType === "assemblies";
    },
    isSource() {
      const { defaultFilters } = get();
      const sourceFilterMatch = defaultFilters.find(
        ({ sourceFilter = void 0 }) => sourceFilter
      );
      if (!sourceFilterMatch) return false;
      const source = sourceFilterMatch.sourceFilter.source;
      return !!source;
    },
    toFilterOptions: (name, filters) => {
      const { defaultFilters } = dropdownFilterStore.getState();
      switch (name) {
        case "GeoShowFilter":
          const showFilterMatch = filters.find(
            ({ geoencodedFilter: geoencodedFilter2 = void 0 }) => geoencodedFilter2
          );
          if (!showFilterMatch) return defaultFilters.GeoShowFilter;
          const geoencodedFilter = showFilterMatch.geoencodedFilter.geoencoded;
          if (geoencodedFilter === true) return "geoencoded";
          if (geoencodedFilter === false) return "virtual";
          return defaultFilters.GeoShowFilter;
        case "GeoScopeFilter":
          const filterGeoScope = filters.find(
            ({ scopeFilter = void 0 }) => scopeFilter
          );
          if (!filterGeoScope) {
            return defaultFilters.GeoScopeFilter;
          }
          return `${filterGeoScope.scopeFilter.scopeId}`;
        case "GeoTimeFilter":
          const timeFilterMatch = filters.find(
            ({ timeFilter: timeFilter2 = void 0 }) => timeFilter2
          );
          if (!timeFilterMatch) return defaultFilters.GeoTimeFilter;
          const timeFilter = timeFilterMatch.timeFilter.time;
          if (timeFilter) return timeFilter;
          return defaultFilters.GeoTimeFilter;
        case "GeoType":
          const typeFilterMatch = filters.find(
            ({ resourceTypeFilter = void 0 }) => resourceTypeFilter
          );
          if (!typeFilterMatch) return defaultFilters.GeoType;
          const id = document.querySelector(".decidimGeo__container").id;
          if ([
            "GeoAccountability",
            "GeoProposals",
            "GeoProposalsItem",
            "GeoMeetings",
            "GeoMeetingsItem",
            "GeoDebatesItem"
          ].includes(id)) {
            const hasAllComponents = [
              "accountability",
              "debates",
              "meetings",
              "proposals"
            ].every((t) => filters.some((f) => {
              var _a;
              return ((_a = f.resourceTypeFilter) == null ? void 0 : _a.resourceType) === t;
            }));
            if (hasAllComponents) {
              return "all";
            }
          }
          const resourceType = typeFilterMatch.resourceTypeFilter.resourceType;
          if (resourceType) {
            return `${resourceType}`;
          }
          return defaultFilters.GeoType;
        case "GeoSource":
          const sourceFilterMatch = filters.find(
            ({ sourceFilter = void 0 }) => sourceFilter
          );
          if (!sourceFilterMatch) return defaultFilters.GeoSource;
          const sourceType = sourceFilterMatch.sourceFilter.source;
          if (sourceType) return `${sourceType}`;
      }
    }
  }))
);
const onFilteredByScope = (filters) => {
  const { scopeFilter } = store.getState();
  const { scopeForId } = pointStore.getState();
  let scopeId;
  const { selectedScope: previousScope } = geoStore.getState();
  const { selectScope } = geoStore.getState();
  if (scopeId = scopeFilter(filters)) {
    if (previousScope && `${scopeId}` === `${previousScope == null ? void 0 : previousScope.id}`) return;
    const selectedScope = scopeForId(scopeId);
    if (selectedScope) selectScope(selectedScope);
    else selectScope(null);
  } else {
    const toRepaintScope = scopeForId(previousScope == null ? void 0 : previousScope.id);
    selectScope(null);
    if (toRepaintScope) {
      toRepaintScope.repaint();
    }
  }
};
store.subscribe(
  (state) => [state.activeFilters],
  (_0, _1) => __async(void 0, [_0, _1], function* ([activeFilters], [previousActiveFilter]) {
    if (activeFilters && _.isEqual(activeFilters, previousActiveFilter)) return;
    if (activeFilters) {
      yield pointStore.getState().pointsForFilters(activeFilters);
    }
    onFilteredByScope(activeFilters);
    const { toFilterOptions } = store.getState();
    const { setFilter } = dropdownFilterStore.getState();
    setFilter("GeoScopeFilter", toFilterOptions("GeoScopeFilter", activeFilters));
    setFilter("GeoShowFilter", toFilterOptions("GeoShowFilter", activeFilters));
    setFilter("GeoTimeFilter", toFilterOptions("GeoTimeFilter", activeFilters));
    setFilter("GeoType", toFilterOptions("GeoType", activeFilters));
    setFilter("GeoSource", toFilterOptions("GeoSource", activeFilters));
    const { updateCurrentCountForFilters } = pointCounterStore.getState();
    const _count = yield updateCurrentCountForFilters(activeFilters);
  })
);
export default store;
